(() => {
  if (window.GrindZealotReviews) {
    window.GrindZealotReviews.initAll();
    return;
  }

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  };

  const createStars = (rating) => {
    const stars = createElement("span", "gz-stars");
    stars.setAttribute("aria-label", `${rating} out of 5 stars`);
    stars.style.setProperty(
      "--gz-rating-percent",
      `${Math.max(0, Math.min(100, (Number(rating) / 5) * 100))}%`,
    );
    return stars;
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(`${value}T00:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat(document.documentElement.lang || "en", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  };

  const renderReviewCard = (review) => {
    const card = createElement("article", "gz-review-card");
    const top = createElement("div", "gz-review-card__top");
    const identity = createElement("div");
    identity.append(createElement("h3", "gz-review-card__author", review.author || "Customer"));
    if (review.verified) {
      identity.append(createElement("span", "gz-review-card__verified", "Verified review"));
    }
    top.append(identity, createElement("time", "gz-review-card__date", formatDate(review.date)));
    card.append(top, createStars(Number(review.rating) || 0));

    if (review.body) {
      card.append(createElement("p", "gz-review-card__body", review.body));
    }

    if (Array.isArray(review.photos) && review.photos.length) {
      const photos = createElement("div", "gz-review-card__photos");
      review.photos.slice(0, 6).forEach((photo, index) => {
        const link = createElement("a", "gz-review-card__photo");
        link.href = photo.url;
        link.target = "_blank";
        link.rel = "noopener";
        link.setAttribute("aria-label", `Open customer photo ${index + 1}`);

        const image = document.createElement("img");
        image.src = photo.url;
        image.alt = "Customer review photo";
        image.loading = "lazy";
        image.decoding = "async";
        if (photo.width) image.width = Number(photo.width);
        if (photo.height) image.height = Number(photo.height);
        link.append(image);
        photos.append(link);
      });
      card.append(photos);
    }

    if (review.reply) {
      const reply = createElement("div", "gz-review-card__reply");
      reply.append(
        createElement("strong", "", "Grind Zealot replied"),
        createElement("span", "", review.reply),
      );
      card.append(reply);
    }

    return card;
  };

  const readReviews = (root) => {
    const data = root.querySelector("[data-gz-review-data]");
    if (!data) return [];

    try {
      const parsed = JSON.parse(data.textContent);
      return (Array.isArray(parsed) ? parsed : [])
        .flat()
        .filter((review) => review && typeof review === "object");
    } catch (error) {
      console.error("Grind Zealot reviews could not be parsed.", error);
      return [];
    }
  };

  const initProductReviews = (root) => {
    if (root.dataset.gzReady === "true") return;
    root.dataset.gzReady = "true";

    const reviews = readReviews(root);
    const grid = root.querySelector("[data-gz-review-grid]");
    const loadMore = root.querySelector("[data-gz-load-more]");
    const empty = root.querySelector("[data-gz-review-empty]");
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 12);
    let visibleCount = Math.max(pageSize, Number(root.dataset.initialReviews) || pageSize);

    const render = () => {
      if (!grid) return;
      grid.replaceChildren(...reviews.slice(0, visibleCount).map(renderReviewCard));
      if (empty) empty.hidden = reviews.length > 0;
      if (loadMore) loadMore.hidden = visibleCount >= reviews.length;
    };

    loadMore?.addEventListener("click", () => {
      visibleCount += pageSize;
      render();
      grid?.lastElementChild?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });

    render();
  };

  const initFeaturedReviews = (root) => {
    if (root.dataset.gzReady === "true") return;
    root.dataset.gzReady = "true";

    const reviews = readReviews(root);
    const grid = root.querySelector("[data-gz-featured-review-grid]");
    const maximum = Math.max(1, Number(root.dataset.maxReviews) || 3);
    const withPhotos = reviews.filter((review) => Array.isArray(review.photos) && review.photos.length);
    const selected = [...withPhotos, ...reviews.filter((review) => !withPhotos.includes(review))]
      .slice(0, maximum);

    if (grid) grid.replaceChildren(...selected.map(renderReviewCard));
  };

  const initDialogs = () => {
    document.querySelectorAll("[data-gz-open-review-form]").forEach((button) => {
      if (button.dataset.gzReady === "true") return;
      button.dataset.gzReady = "true";
      button.addEventListener("click", () => {
        const dialog = document.getElementById(button.getAttribute("aria-controls"));
        if (!dialog) return;
        if (typeof dialog.showModal === "function") dialog.showModal();
        else dialog.setAttribute("open", "");
      });
    });

    document.querySelectorAll("[data-gz-close-dialog]").forEach((button) => {
      if (button.dataset.gzReady === "true") return;
      button.dataset.gzReady = "true";
      button.addEventListener("click", () => button.closest("dialog")?.close());
    });

    document.querySelectorAll(".gz-review-dialog").forEach((dialog) => {
      if (dialog.dataset.gzBackdropReady === "true") return;
      dialog.dataset.gzBackdropReady = "true";
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll("[data-gz-product-reviews]").forEach(initProductReviews);
    document.querySelectorAll("[data-gz-featured-reviews]").forEach(initFeaturedReviews);
    initDialogs();
  };

  window.GrindZealotReviews = { initAll };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
